import axios from "axios";
import { store } from "redux/store";

import {
  ICaptchaRefresh,
  ICardTemp,
  IFirstPasswordChange,
  IFirstPasswordChangeAdmin,
  IPasswordCardInfo,
  IPasswordCardInfoRequest,
  IPasswordChange,
  IPasswordPersonelInfo,
  INewPasswordPersonelInfoRequest,
  IPasswordSendResponse,
  IPersonelInfoTemp,
  ISecPhotoList,
  ISelectedSecPhoto,
} from "models/Password/password.model";
import { ITokenModel } from "models/Login/token.model";
import { RSAEncrypt } from "utils/CryptOperations/Rsa-encrypt";

export const PasswordRefresh_personelInfo = async (
  //FRM buraya yeni service yaz
  passPersonelInfoParams: INewPasswordPersonelInfoRequest
): Promise<IPasswordPersonelInfo> => {
  const reduxStore = store.getState();

  const _clientUid = reduxStore.PassRefPersonelInfo.clientUID;
  // passPersonelInfoParams.clientUid = reduxStore.PassRefPersonelInfo.clientUID;
  const reqData = servicePassModelCreator(passPersonelInfoParams, _clientUid);
  try {
    const { data } = await axios.post<IPasswordPersonelInfo>("/Token", reqData);

    if (data.Captcha && data.Captcha.length > 0) return data;
    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    const tmp: IPersonelInfoTemp = {
      merchantNo: passPersonelInfoParams.merchantNo,
      phoneNumber: passPersonelInfoParams.phoneNumber,
    };
    data.personelInfoTemp = { ...tmp };

    return data;
  } catch (error) {
    console.log(`PASSWORD_REFRESH_PERSONELINFO_SERVICE_ERROR => `, error);
    throw error;
  }
};

const servicePassModelCreator = (
  passPersonelInfoParams: INewPasswordPersonelInfoRequest,
  clientUID: string
) => {
  let req = {
    // Captcha: passPersonelInfoParams.Captcha
    //   ? RSAEncrypt(passPersonelInfoParams.Captcha!)
    //   : "",
    // CCLastFourDigit: RSAEncrypt(passPersonelInfoParams.CCLastFourDigit!),
    // MBB: passPersonelInfoParams.MBB,
    // TCKN: null,
    // androidUID: null,
    // carrier: null,
    // changeKey: null,
    // ChannelKey: "POS-RTL-WUN-MBB",
    // clientDeviceID: null,
    // ClientUid: clientUID, //"59C627061C209BBE",
    // connectionType: null,
    // DeviceBrand: null,
    // DeviceModel: null,
    // deviceOs: null,
    // deviceOsType: null,
    // DeviceOsVersion: null,
    // deviceType: null,
    // deviceVersion: null,
    // hardOtpFlag: false,
    // imei: null,
    // isCracked: null,
    // softOtpFlag: null,
    // kullAdiEnc: null,
    // userAgent: null,
    // CallbackFunctionId: null,
    // isBusy: false,
    // isNativeFlag: "true",
    // Language: "tr-TR",
    // igsEnc: null,
    // TokenSessionId: "",
    // NextTransactionUrl: "ModAuthNativePassForgetFirstStep",
    MobileNo: passPersonelInfoParams.phoneNumber,
    MerchantNo: passPersonelInfoParams.merchantNo,
    DeviceApplicationVersion: "1.3.5",
    Carrier: "WIFI",
    ConnectionType: "WIFI",
    DeviceOs:
      "ANDROID 8.0.0|V1.2.8|SAMSUNG SM-G935F|TR|414635443430384234453032|Galaxy S7 edge",
    DeviceType: "SMARTPHONE-MPOS",
    Imei: clientUID, //"2C9E6FBAC0C3728D",
    IsCracked: "0",
    ClientUid: clientUID, //"2C9E6FBAC0C3728D",
    ChannelKey: "POS-RTL-WUN-MBB",
    DeviceBrand: "samsung",
    DeviceModel: "SM-A307FN",
    DeviceOsVersion: "11",
    hardOtpFlag: false,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    NextTransactionUrl: "ModAuthAndroidPosPassForgetFirst",
    deviceTimestamp: "1748202219293",
    isScreenMirroring: false,
    IsFirst: passPersonelInfoParams.IsFirst ?? true,
  };

  return req;
};

export const PasswordRefresh_refreshCaptcha = async (): Promise<ICaptchaRefresh> => {
  const reduxStore = store.getState();
  const tokenSessId =
    reduxStore.PassRefPersonelInfo.passwordInfo?.TokenSessionId;
  const reqData = refreshCaptchaModelCreator(tokenSessId!);

  try {
    const { data } = await axios.post<ICaptchaRefresh>("/Token", reqData);

    if (data.DialogBoxes.length > 0) return data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`PASSWORD_REFRESH_CAPTCHAREFRESH_SERVICE_ERROR => `, error);
    return error;
  }
};

const refreshCaptchaModelCreator = (captchaTokenSessionId: string) => {
  let req = {
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: captchaTokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "ModAuthNativePassForgetRefreshCaptcha",
  };

  return req;
};

export const PasswordRefresh_cardInfo = async (
  passCardInfoParams: IPasswordCardInfoRequest
): Promise<IPasswordCardInfo> => {
  const reduxStore = store.getState();
  const tokenSessionId =
    reduxStore.PassRefPersonelInfo.passwordInfo?.TokenSessionId;
  passCardInfoParams.TokenSessionId = tokenSessionId;

  const reqData = servicePassCardModelCreator(passCardInfoParams);

  try {
    const { data } = await axios.post<IPasswordCardInfo>("/Token", reqData);

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    const tmp: ICardTemp = {
      PinDigitEnc: passCardInfoParams.PinDigitEnc,
      TokenSessionId: tokenSessionId,
    };
    data.cardTemp = { ...tmp };

    return data;
  } catch (error) {
    console.log(`PASSWORD_REFRESH_CARDINFO_SERVICE_ERROR => `, error);
    throw error;
  }
};

const servicePassCardModelCreator = (
  passCardInfoParams: IPasswordCardInfoRequest
) => {
  let req = {
    PinDigitEnc: RSAEncrypt(passCardInfoParams.PinDigitEnc!),
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: passCardInfoParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "ModAuthNativePassForgetVerifyPin",
  };

  return req;
};

export const passwordChangeAsync = async (
  token: ITokenModel,
  oldPassword: string,
  newPassword: string
): Promise<IPasswordChange> => {
  const reqData = servicePassChangeModelCreator(
    token.TokenSessionId,
    oldPassword,
    newPassword
  );
  try {
    const { data } = await axios.post<IPasswordChange>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${token.access_token}`,
        },
      }
    );

    if (data.DialogBoxes.length > 0) return data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`PASSWORD_CHANGE_SERVICE_ERROR => `, error);
    return error;
  }
};

const servicePassChangeModelCreator = (
  tokenId: string,
  oldPass: string,
  newPass: string
) => {
  let req = {
    yeniIgs: RSAEncrypt(newPass),
    TokenSessionId: tokenId,
    igsEnc: RSAEncrypt(oldPass),
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    NextTransactionUrl: "ModAuthPosChange/Pass",
  };

  return req;
};

export const PasswordSendAsync = async (
  agentMobilNo: string,
  token: ITokenModel
): Promise<IPasswordSendResponse> => {
  const reqData = servicePasswordSendCreator(
    agentMobilNo,
    token.TokenSessionId
  );
  try {
    const { data } = await axios.post<IPasswordSendResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${token.access_token}`,
        },
      }
    );

    if (
      data.DialogBoxes.length > 0 ||
      (data.ReturnCode !== null && data.ReturnCode != 0)
    ) {
      let mssgg =
        data.DialogBoxes.length > 0
          ? data.DialogBoxes[0].Message
          : "Şu anda size hizmet veremiyoruz. Lütfen daha sonra tekrar deneyiniz.";
      return mssgg;
    }

    return data;
  } catch (error: any) {
    console.log(`PASSWORDSEND_SERVICE_ERROR => `, error);
    return error;
  }
};

const servicePasswordSendCreator = (agentMobilNo: string, tokenId: string) => {
  let req = {
    AgentMobileNo: agentMobilNo,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: tokenId,
    igsEnc: null,
    NextTransactionUrl: "MPSResetPass/ResetPass",
  };

  return req;
};

export const firstPasswordChangeAsync = async (
  token: ITokenModel,
  name: string,
  surname: string,
  newPassword: string
): Promise<IFirstPasswordChange> => {
  const reqData = serviceFirstPassChangeModelCreator(
    token.TokenSessionId,
    name,
    surname,
    newPassword
  );
  try {
    const { data } = await axios.post<IFirstPasswordChange>("/Token", reqData);

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`FIRST_PASSWORD_CHANGE_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceFirstPassChangeModelCreator = (
  tokenId: string,
  name: string,
  surname: string,
  newPass: string
) => {
  let req = {
    Name: name?.length > 0 ? RSAEncrypt(name) : name,
    NewIgs: RSAEncrypt(newPass),
    Surname: surname?.length > 0 ? RSAEncrypt(surname) : surname,
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: tokenId,
    igsEnc: null,
    NextTransactionUrl: "ModAuthPosChangePassAndName",
  };

  return req;
};

export const firstPasswordChangeAdminAsync = async (
  token: ITokenModel,
  newPassword: string
): Promise<IFirstPasswordChangeAdmin> => {
  const reqData = serviceFirstPassChangeAdminModelCreator(
    token.TokenSessionId,
    newPassword
  );
  try {
    const { data } = await axios.post<IFirstPasswordChangeAdmin>(
      "/Token",
      reqData
    );

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`FIRST_PASSWORD_CHANGE_ADMIN_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceFirstPassChangeAdminModelCreator = (
  tokenId: string,
  newPass: string
) => {
  let req = {
    yeniIgs: RSAEncrypt(newPass),
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: tokenId,
    igsEnc: null,
    isScreenMirroring: false,
    NextTransactionUrl: "ModAuthPosChangePass",
  };

  return req;
};

export const AdminSecurityPhotoListAsync = async (
  token: ITokenModel
): Promise<ISecPhotoList> => {
  const reqData = serviceAdminSecurityPhotoListModelCreator(
    token.TokenSessionId
  );
  try {
    const { data } = await axios.post<ISecPhotoList>("/Token", reqData);

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`ADMIN_SECURITY_PHOTO_LIST_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceAdminSecurityPhotoListModelCreator = (tokenId: string) => {
  let req = {
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: "BEB82C184B20A692",
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: tokenId,
    igsEnc: null,
    isScreenMirroring: false,
    NextTransactionUrl: "ModAuthChangeSecPicFirst",
  };

  return req;
};

export const AdminSelectedSecurityPhotoAsync = async (
  token: ITokenModel,
  selectedPhoto: string
): Promise<ISelectedSecPhoto> => {
  const reqData = serviceAdminSelectedSecurityPhotoModelCreator(
    token.TokenSessionId,
    selectedPhoto
  );
  try {
    const { data } = await axios.post<ISelectedSecPhoto>("/Token", reqData);

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`ADMIN_SELECTED_SECURITY_PHOTO_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceAdminSelectedSecurityPhotoModelCreator = (
  tokenId: string,
  selectedPhoto: string
) => {
  let req = {
    secPicId: selectedPhoto,
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: tokenId,
    igsEnc: null,
    isScreenMirroring: false,
    NextTransactionUrl: "ModAuthChangeSecPicComplete",
  };

  return req;
};
